import React from "react";
import { Routes, Route } from "react-router-dom";
import ThemeProvider from "./components/ThemeProvider";
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Portfolio from "./pages/Portfolio";
import Resources from "./pages/Resources";
import Contact from "./pages/Contact";

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <div className="app">
        <ScrollToTop />
        <Navbar />
        <main style={{ minHeight: "100vh", overflowX: "hidden", width: "100%" }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
      </div>
    </ThemeProvider>
  );
};

export default App;
